import { use, useState } from "react";
import styles from "./Content.module.css";
import HeaderContent from "./header/HeaderContent";
import PageContent from "./pages/PageContent";

function Content({ view, menuFilterParams, filterControl}) {
  // Parametro geral
  const [selectedDistrito, setSelectedDistrito] = useState("Todos");

  // Parâmetro de produção
  const [areaMin, setAreaMin] = useState(0.0);
  const [areaMax, setAreaMax] = useState(1000000000);
  const [prodMin, setProdMin] = useState(0.0);
  const [prodMax, setProdMax] = useState(1000000000);

  const areaValues = {
    areaMin,
    areaMax,
  };

  const prodValues = {
    prodMin,
    prodMax,
  };

  const setAreaControls = {
    setAreaMin,
    setAreaMax,
  };

  const setProdControls = {
    setProdMin,
    setProdMax,
  };

  // Parâmetro de condições gerais
  const [carroProprioValue, setCarroProprioValue] = useState(null);
  const [energiaEletricaValue, setEnergiaEletricaValue] = useState(null);
  const [abastecimentoAguaValue, setAbastecimentoAguaValue] = useState(null);
  const [tipoFossaValue, setTipoFossaValue] = useState(null);
  const [descarteLixoValue, setDescarteLixoValue] = useState(null);
  const [descarteEsgotoValue, setDescarteEsgotoValue] = useState(null);

  const generalConditionValues = {
    carroProprioValue,
    energiaEletricaValue,
    abastecimentoAguaValue,
    tipoFossaValue,
    descarteLixoValue,
    descarteEsgotoValue,
  };

  const setGeneralConditionsValuesControls = {
    setCarroProprioValue,
    setEnergiaEletricaValue,
    setAbastecimentoAguaValue,
    setTipoFossaValue,
    setDescarteLixoValue,
    setDescarteEsgotoValue,
  };

  // Parâmetros de Saúde
  const [frequenciaExameValue, setFrequenciaExameValue] = useState(null);
  const [atendimentoAmbulanciaValue, setAtendimentoAmbulanciaValue] = useState(null);
  const [sistemaSaudeValue, setSistemaSaudeValue] = useState(null);
  const [usoMedicamentoValue, setUsoMedicamentoValue] = useState(null);
  const [dificuldadeAtendimentoValue, setDificuldadeAtendimentoValue] = useState(null);
  const [qualidadeSSMunicipalValue, setQualidadeSSMunicipalValue] =  useState(null);
  const [qualidadeSSRuralValue, setQualidadeSSRuralValue] = useState(null);
  const [possuiDoencaCronicaValue, setPossuiDoencaCronicaValue] = useState(null);
  const [tipoDoencaCronicaValue, setTipoDoencaCronicaValue] = useState(null);
  const [programaSaudeRuralValue, setProgramaSaudeRuralValue] = useState(null);

  const setHealthControls = {setFrequenciaExameValue, setAtendimentoAmbulanciaValue, setSistemaSaudeValue, setUsoMedicamentoValue, setDificuldadeAtendimentoValue, setQualidadeSSMunicipalValue, setQualidadeSSRuralValue, setPossuiDoencaCronicaValue, setTipoDoencaCronicaValue, setProgramaSaudeRuralValue}
  const healthValues = {frequenciaExameValue, atendimentoAmbulanciaValue, sistemaSaudeValue, usoMedicamentoValue, dificuldadeAtendimentoValue, qualidadeSSMunicipalValue, qualidadeSSRuralValue, possuiDoencaCronicaValue, tipoDoencaCronicaValue, programaSaudeRuralValue}

  // Parâmetro de imagens
  const [prodAgropecImage, setProdAgropecImage] = useState(null);
  const [mapImage, setMapImage] = useState(null);
  const [mapImage2, setMapImage2] = useState(null);
  const [imovelImage, setImovelImage] = useState(null);
  const [naturezaImage, setNaturezaImage] = useState(null);
  const [carroImage, setCarroImage] = useState(null);
  const [energiaImage, setEnergiaImage] = useState(null);
  const [aguaImage, setAguaImage] = useState(null);
  const [fossaImage, setFossaImage] = useState(null);
  const [lixoImage, setLixoImage] = useState(null);
  const [esgotoImage, setEsgotoImage] = useState(null);
  const [captacaoAguaImage, setCaptacaoAguaImage] = useState(null);

  const [frequenciaExameImage, setFrequenciaExameImage] = useState(null);
  const [atendimentoAmbulanciaImage, setAtendimentoAmbulanciaImage] = useState(null);
  const [sistemaSaudeImage, setSistemaSaudeImage] = useState(null);
  const [usoMedicamentoImage, setUsoMedicamentoImage] = useState(null);
  const [dificuldadeAtendimentoImage, setDificuldadeAtendimentoImage] = useState(null);
  const [qualidadeSSMunicipalImage, setQualidadeSSMunicipalImage] = useState(null);
  const [qualidadeSSRuralImage, setQualidadeSSRuralImage] = useState(null);
  const [possuiDoencaCronicaImage, setPossuiDoencaCronicaImage] = useState(null);
  const [tipoDoencaCronicaImage, setTipoDoencaCronicaImage] = useState(null);
  const [programaSaudeRuralImage, setProgramaSaudeRuralImage] = useState(null);

  const setImageControls = {
    setCaptacaoAguaImage,
    setProdAgropecImage,
    setMapImage,
    setMapImage2,
    setImovelImage,
    setNaturezaImage,
    setCarroImage,
    setEnergiaImage,
    setAguaImage,
    setFossaImage,
    setLixoImage,
    setEsgotoImage,
    setFrequenciaExameImage,
    setAtendimentoAmbulanciaImage,
    setSistemaSaudeImage,
    setUsoMedicamentoImage,
    setDificuldadeAtendimentoImage,
    setQualidadeSSMunicipalImage,
    setQualidadeSSRuralImage,
    setPossuiDoencaCronicaImage,
    setTipoDoencaCronicaImage,
    setProgramaSaudeRuralImage
  };

  const setters = {
    setImageControls,
    setAreaControls,
    setProdControls,
    setGeneralConditionsValuesControls,
    setHealthControls
  };

  const values = {
    areaValues,
    prodValues,
    generalConditionValues,
    healthValues
  };

  const { onFilterClick, selectedOption, searchInput } = filterControl;

  return (
    <div className={styles.content}>
      <HeaderContent
        view={view}
        distrito={selectedDistrito}
        menuFilterParams={menuFilterParams}
        values={values}
        filterOptions={{
          onFilterClick,
          selectedOption: selectedDistrito,
          onSelectChange: setSelectedDistrito,
        }}
        setGeneralConditionsValuesControls={setGeneralConditionsValuesControls}
        imgParams={{
          prodAgropecImage,
          mapImage,
          mapImage2,
          imovelImage,
          naturezaImage,
          carroImage,
          energiaImage,
          aguaImage,
          captacaoAguaImage,
          fossaImage,
          lixoImage,
          esgotoImage,
        }}
      />
      <PageContent
        view={view}
        distrito={selectedDistrito}
        menuFilterParams={menuFilterParams}
        options={{
          onDistrictMapChange: setSelectedDistrito,
          selectedOption,
          searchInput,
        }}
        setters={setters}
        values={values}
      />
    </div>
  );
}

export default Content;
